<template>
  <div class="">
    <card>
      <template v-slot:header>
        <div class="row">
          <div class="col-9">
            <h3>صدور پــیش فاکــــتور</h3>
          </div>
          <div class="col-3">
            <button
              class="btn btn-warning float-left"
              @click="returnToCustomer"
              v-if="InTempFactor || propsCustomerId"
            >
              بازگشت به مشتری
            </button>
          </div>
        </div>
        <hr />
      </template>
      <template v-slot:content>
        <div class="row" id="tempFactorAdd">
          <div class="col-md-4 col-12">
            <small id="LblTblCostomer">مربوط به مشتری</small>
            <SearchableCombo
              v-if="$store.state.renderComponentGrid"
              :edit="false"
              :grp="0"
              :code="null"
              @ResultCombo="GetResultTblCostomer"
              :rownumintable="3"
              :defaultvalue="DataAxios.TblCustomerId"
              :action="'TblCrmCombo/GetCostomer'"
              :method="'POST'"
              :idinput="'TblCostomer'"
              :keyItem="'TblCostomer'"
              :disabled="
                DataAxios.TblCustomerId != 0 && DataAxios.TblCustomerId != null
              "
              :ClassProps="'required'"
            >
            </SearchableCombo>
          </div>
          <div class="col-md-4 col-12">
            <small id="LblTblCostomer">مشخصات روی فاکتور</small>
            <SearchableCombo
              v-if="$store.state.renderComponentCombo"
              :edit="false"
              :grp="DataAxios.TblCustomerId"
              :code="null"
              @ResultCombo="GetResultTblCostomerFinancial"
              :rownumintable="3"
              :defaultvalue="DataAxios.tblCustomerFinancialINvoiceID"
              :action="'TblCrmCombo/GetCustomerFinanace'"
              :method="'POST'"
              :idinput="'TblCostomerF'"
              :keyItem="'TblCostomerF'"
              :disabled="DataAxios.TblCustomerId == null"
            >
            </SearchableCombo>
          </div>
          <div class="col-md-4 col-12" dir="rtl">
            <small id="LblTblCustomerProduct"> انتخاب محصولات </small>
            <treeselect
              name="CustomerContract"
              :multiple="multiple"
              :clearable="clearable"
              :searchable="searchable"
              :disabled="disabled"
              :open-on-click="openOnClick"
              :open-on-focus="openOnFocus"
              :clear-on-select="clearOnSelect"
              :close-on-select="closeOnSelect"
              :always-open="alwaysOpen"
              :append-to-body="appendToBody"
              :options="options"
              v-model="value"
              :normalizer="normalizer"
              @select="ItemSelected"
              @deselect="ItemDeselect"
            >
            </treeselect>
          </div>
          <div class="col-md-4 col-12 mt-4 form-control text-center">
            <div class="custom-control custom-switch">
              <small id="LbltblComboGrpId50" class="ml-2"> رسمی</small>
              <input
                type="checkbox"
                class="custom-control-input InputText"
                @change="change"
                id="Done"
                v-model="DataAxios.isRasmi"
              />
              <label class="custom-control-label" for="Done"> </label>
              <small class="mr-5"> غیررسمی</small>
            </div>
          </div>
          <div class="col-md-4 col-12">
            <small id="LblTblCostomer"> پانویس فاکتور </small>
            <SearchableCombo
              v-if="$store.state.renderComponentGrid"
              :edit="false"
              :grp="51"
              :code="null"
              @ResultCombo="GetResultPishNevis"
              :rownumintable="3"
              :defaultvalue="null"
              :action="'TblCrmCombo/GetComboById'"
              :method="'POST'"
              :idinput="'TblFactorPish'"
              :keyItem="'TblFactorPish'"
              :ClassProps="DataAxios.isRasmi ? 'required' : ''"
            >
            </SearchableCombo>
          </div>
          <div class="col-md-4 col-12">
            <small id="LblTaskDateTa"> تاریخ</small>
            <date-picker
              color="dimgray"
              v-model="DataAxios.TempFactorDate"
              clearable
              :editable="true"
              placeholder=" تاریخ "
            ></date-picker>
          </div>
        </div>
      </template>
    </card>

    <card>
      <template v-slot:header>
        <h3>پــیش فاکــــتور</h3>
        <hr />
      </template>
      <template v-slot:content>
        <table
          v-if="$store.state.renderComponentGrid"
          class="table table-bordered table-hover mt-2"
        >
          <thead class="">
            <tr>
              <th style="width: 1% !important">ردیف</th>
              <th style="width: 5% !important">کد کالا</th>
              <th style="width: 25% !important">شرح کالا | خدمات</th>
              <th style="width: 10% !important">تعداد</th>
              <th style="width: 10% !important">
                مبلغ واحد <small>( ریال )</small>
              </th>
              <!-- <th style="width: 10% !important">
                مبلغ کل <small class="d-block">( ریال )</small>
              </th> -->
              <th style="width: 10% !important">مبلغ تخفیف</th>
              <th style="width: 10% !important">
                مبلغ پس از تخفیف <small class="d-block">( ریال )</small>
              </th>
              <th v-if="DataAxios.isRasmi" style="width: 10% !important">
                جمع مالیات و عوارض <small>( ریال )</small>
              </th>
              <th v-if="DataAxios.isRasmi" style="width: 10%">
                جمع مبلغ با احتساب مالیات و عوارض <small>( ریال )</small>
              </th>
              <th style="width: 10% !important">نیاز به تمدید</th>
            </tr>
          </thead>
          <tbody class="" id="GFactor">
            <tr v-for="(item, index) in PishFactorList" :key="index">
              <td style="width: 1% !important">
                <span>{{ index + 1 }}</span>
              </td>
              <td style="width: 5% !important">
                <span>{{ InTempFactor ? item.tblProductsId : item.id }}</span>
              </td>

              <td style="width: 25% !important; text-align: center">
                <input
                  type="text"
                  class="form-control 3ragham required"
                  v-model="item.NameProduct"
                />
              </td>
              <td style="width: 5% !important; text-align: center">
                <input
                  type="number"
                  class="form-control text-center required"
                  @keyup="
                    CalcCount($event, item);
                    item.Count = $PutCommatoInput_New($event);
                  "
                  v-model="item.Count"
                />
              </td>
              <td style="width: 10% !important; text-align: center">
                <input
                  type="text"
                  class="form-control text-center 3ragham required"
                  @keyup="
                    CalcAmount($event, item);
                    item.Amount = $PutCommatoInput_New($event);
                  "
                  v-model="item.Amount"
                />
              </td>
              <!-- <td style="text-align: center">
                {{ $Comma3ragham(item.AmountKol) }}
              </td> -->
              <td style="width: 10% !important; text-align: center">
                <input
                  type="text"
                  class="form-control text-center 3ragham required"
                  @keyup="
                    CalcDiscount($event, item),
                      (item.Discount = $PutCommatoInput_New($event))
                  "
                  v-model="item.Discount"
                />
              </td>
              <td style="width: 10% !important; text-align: center">
                {{ $Comma3ragham(item.Miniaturize_AmountDiscount) }}
              </td>

              <td
                v-if="DataAxios.isRasmi"
                style="width: 10% !important; text-align: center"
              >
                {{ $Comma3ragham(item.SumTollTax) }}
              </td>
              <td v-if="DataAxios.isRasmi" style="text-align: center">
                <span>{{ $Comma3ragham(item.TotallAmount) }}</span>
              </td>
              <td class="text-center">
                <input
                  class="Pointer"
                  type="checkbox"
                  v-model="item.NeedSubmit"
                />
              </td>
            </tr>
            <tr v-if="IsCalc && PishFactorList.length > 0">
              <td colspan="4" style="text-align: left">جمع کـــل :</td>
              <td style="text-align: center" class="bg-secondary">
                {{ $Comma3ragham(TR_Result.S_Amount) }}
              </td>
              <td style="text-align: center" class="bg-secondary">
                {{ $Comma3ragham(TR_Result.S_Discount) }}
              </td>
              <td style="text-align: center" class="bg-secondary">
                {{ $Comma3ragham(TR_Result.S_Miniaturize_AmountDiscount) }}
              </td>
              <td
                v-if="DataAxios.isRasmi"
                style="text-align: center"
                class="bg-secondary"
              >
                {{ $Comma3ragham(TR_Result.S_SumTollTax) }}
              </td>
              <td
                v-if="DataAxios.isRasmi"
                style="text-align: center"
                class="bg-secondary"
              >
                {{ $Comma3ragham(TR_Result.S_SumTotallAmount) }}
              </td>
              <td></td>
            </tr>
            <tr v-if="IsCalc && PishFactorList.length > 0" class="mt-3">
              <td colspan="6" style="text-align: right">
                <input
                  v-if="render"
                  type="text"
                  placeholder="توضیحات فاکــــتور"
                  class="form-control 3ragham"
                  v-model="DataAxios.TempDesc"
                />
              </td>
              <td colspan="6" style="text-align: right">
                <span class="mt-2">
                  جمع کل مبلغ به حروف :
                  <b class="font-weight-bold">
                    {{
                      Mab2persian(
                        DataAxios.isRasmi
                          ? TR_Result.S_SumTotallAmount
                          : TR_Result.S_Miniaturize_AmountDiscount
                      )
                    }}</b
                  ></span
                >
              </td>
            </tr>
          </tbody>
        </table>
        <div class="row">
          <div class="col-md-3 col-12">
            <button
              class="btn btn-success"
              v-if="(!InTempFactor && PishFactorList.length > 0) || propsCopy"
              @click="AddTempFactor"
            >
              ثبت پیشــ فاکتــــور
            </button>
            <button
              class="btn btn-warning"
              v-if="InTempFactor && PishFactorList.length > 0 && !propsCopy"
              @click="EditTempFactor"
            >
              ویـرایــش پیشــ فاکتــــور
            </button>
          </div>
        </div>
      </template>
    </card>
  </div>
</template>
<script>
import Num2persian from "num2persian";
import Card from "../../../components/Card/Card.vue";
import SearchableCombo from "../../../components/Combo/SearchableCombo.vue";
import Treeselect from "@riophae/vue-treeselect";
import VuePersianDatetimePicker from "vue-persian-datetime-picker";

export default {
  components: {
    Card,
    SearchableCombo,
    Treeselect,
    datePicker: VuePersianDatetimePicker,
  },
  data() {
    return{
      ArzeshAfzode1402:0.09,
      ArzeshAfzode1403 :0.1,
      render: true,
      refGetResulContract: null,
      DataAxios: {
        TblCustomerId: 0,
        TblContractId: 0,
        Description: "",
        isRasmi: true,
        IssueDate: "",
        TempFactorDate: this.$store.state.JalaliDate,
        SerialId: "",
        tblCustomerFinancialINvoiceID: null,
      },
      options: [],
      multiple: true,
      clearable: false,
      searchable: true,
      disabled: false,
      openOnClick: true,
      openOnFocus: false,
      clearOnSelect: true,
      closeOnSelect: false,
      alwaysOpen: false,
      appendToBody: false,
      value: [],
      normalizer(node) {
        return {
          id: node.Id,
          label: node.Name,
        };
      },
      ListProducts: [],
      IsCalc: false,
      TR_Result: {
        S_Amount: 0,
        S_Discount: 0,
        S_Miniaturize_AmountDiscount: 0,
        S_SumTollTax: 0,
        S_SumTotallAmount: 0,
      },
      CopyCustomerProducts: [],
      Factors: [],
      ErrorList: [],
      PishFactorList: [],
      EmptyRowPishFactor: {
        id: null,
        Name: null,
        Count: 1,
        Amount: 0,
        Discount: 0,
        TollandTax: 0,
        TotallAmount: 0,
        AmountKol: 0,
        Miniaturize_AmountDiscount: 0,
        SumTollTax: 0,
        NeedSubmit: false,
      },
    };
  },
  props: [
    "propstblCustomerProducts",
    "InTempFactor",
    "propsCustomerId",
    "propsCopy",
  ],
  methods: {
    returnToCustomer() {
      this.$router.push({
        name: "DetailCustomer",
        params: {
          tblCustomerId: this.DataAxios.tblCustomerId
            ? this.DataAxios.tblCustomerId
            : this.propsCustomerId,
          activeTab: 11,
        },
      });
    },
    change() {
      this.$store.state.renderComponentGrid = false;
      this.$nextTick(() => {
        this.$store.state.renderComponentGrid = true;
      });
    },
    GetTempFactor() {
      var GetTempAxios = {
        Method: "POST",
        Action: "TempFactor/GetById",
        ArryfildValue: { Id: Number(this.InTempFactor.Id) },
      };
      this.$PostData(GetTempAxios).then((result) => {
        if (result.status == "success") {
        console.log('Result',result.tempFactor.dateTimeInsert);
          this.DataAxios.SerialId = result.tempFactor.serial;
          this.DataAxios.TempFactorDate = result.tempFactor.tempFactorDate;
          this.DataAxios.tblCustomerId = result.tempFactor.tblCustomerId;
          this.DataAxios.tblUsergrpIdInsert =
            result.tempFactor.tblUsergrpIdInsert;
          this.DataAxios.dateTimeInsert = result.tempFactor.dateTimeInsert;
          this.DataAxios.id = result.tempFactor.id;
          this.DataAxios.isRasmi = result.tempFactor.isRasmi;
          this.DataAxios.TempDesc = result.tempFactor.tempDesc;
          this.TempFactor = {
            tempFactor: result.tempFactor,
            TempFactorDetail: result.tempFactorDetail,
            address: result.address,
            shobe: result.shobe,
          };
          console.log("🤦🏻‍♂️ ~ file: TempFactor.vue:433 ~ this.TempFactor:", this.TempFactor)

          result.tempFactorDetail.forEach((element) => {
            this.value.push(element.tblProductsId);
            var temp = JSON.parse(JSON.stringify(this.EmptyRowPishFactor));
            temp.id = element.id;
            temp.Name = element.name;
            temp.Count = element.count;
            temp.Discount = this.$Comma3ragham(element.discount);
            temp.Amount = this.$Comma3ragham(element.amount);
            temp.AmountKol = element.amount * element.count;
            temp.Miniaturize_AmountDiscount = temp.AmountKol - temp.Discount;
            // console.log(temp.AmountKol, Number(temp.AmountKol));
            temp.SumTollTax = (temp.AmountKol - element.discount) * (this.TempFactor.tempFactor.tempFactorDate.substring(0, 4)<'1403' ? this.ArzeshAfzode1402 : this.ArzeshAfzode1403);
            temp.TotallAmount =
              temp.AmountKol - element.discount + temp.SumTollTax;
            temp.tblProductsId = element.tblProductsId;
            temp.tblUserGrpIdInsert = result.tempFactor.tblUserGrpIdInsert;
            temp.dateTimeInsert = result.tempFactor.dateTimeInsert;
            temp.NameProduct = element.nameProduct;
            temp.NeedSubmit = element.needSubmit;

            this.PishFactorList.push(temp);
            this.CalcFactor();
          });
          this.PishFactorList.forEach((element) => {
            // this.CalcDiscountDetail(null, element)
          });
          this.DataAxios.TblCustomerId = result.tempFactor.tblCustomerId;
          this.DataAxios.tblCustomerFinancialINvoiceID =
            result.tempFactor.tblCustomerFinancialINvoiceID;
          if (this.propsCopy) {
            this.DataAxios.IssueDate = this.$GetJalaliDate();
            this.GetSerialNum();
            // console.log(this.DataAxios);
          }
          this.$store.state.renderComponentCombo = false;
          this.$nextTick(() => {
            this.$store.state.renderComponentCombo = true;
          });
        } else {
        }
      });
    },
    GetResultTblCostomer(val) {
      if (val.id != null) {
        this.DataAxios.TblCustomerId = val.id;
        if (!this.InTempFactor) {
          this.DataAxios.tblCustomerFinancialINvoiceID = null;
        }
        this.$store.state.renderComponentCombo = false;
        this.$nextTick(() => {
          this.$store.state.renderComponentCombo = true;
        });
      }
    },
    GetProducts(val) {
      let DataAxios_GetData = {
        ArryfildValue: {},
        Method: "Get",
        Action: "Products",
        Token: this.$session.get("Token"),
      };

      this.$PostData(DataAxios_GetData)
        .then((data) => {
          this.options = data.Rrsult;
        })
        .finally(() => {
          this.$store.state.renderComponentGrid = false;
          this.$nextTick(() => {
            this.$store.state.renderComponentGrid = true;
          });
        });
    },
    ItemSelected(node) {
      var temp = JSON.parse(JSON.stringify(this.EmptyRowPishFactor));
      temp.id = 0;
      temp.tblProductsId = node.Id;
      temp.Name = node.Name;
      temp.NameProduct = node.Name;
      temp.NeedSubmit = node.NeedSubmit;
      // console.log(temp);
      this.PishFactorList.push(temp);
    },
    ItemDeselect(node) {
      for (let index = 0; index < this.value.length; index++) {
        if (this.value[index].Id == node.Id) {
          this.value.splice(index, 1);
        }
      }
      for (let index = 0; index < this.PishFactorList.length; index++) {
        if (this.InTempFactor) {
          if (this.PishFactorList[index].tblProductsId == node.Id) {
            this.PishFactorList.splice(index, 1);
            this.CalcFactor();
          }
          this.CalcFactor();
        } else {
          if (this.PishFactorList[index].tblProductsId == node.Id) {
            this.PishFactorList.splice(index, 1);

            this.CalcFactor();
          }
        }
      }
    },
    CalcFactor() {
      this.TR_Result.S_Amount = 0;
      this.TR_Result.S_Discount = 0;
      this.TR_Result.S_Miniaturize_AmountDiscount = 0;
      this.TR_Result.S_SumTollTax = 0;
      this.TR_Result.S_SumTotallAmount = 0;
      this.PishFactorList.forEach((el) => {
        this.TR_Result.S_Amount += Number(el.AmountKol);

        if (typeof el.Discount === "string")
          this.TR_Result.S_Discount += Number(
            el.Discount.replace(/,/g, "").replace(/\./g, "")
          );
        else this.TR_Result.S_Discount += Number(el.Discount);

        var d =
          typeof el.Discount === "string"
            ? Number(el.Discount.replace(/,/g, "").replace(/\./g, ""))
            : Number(el.Discount);
        this.TR_Result.S_Miniaturize_AmountDiscount += Number(el.AmountKol) - d;
        this.TR_Result.S_SumTollTax += Number(el.AmountKol - d) *(this.DataAxios.TempFactorDate.substring(0, 4)<'1403' ? this.ArzeshAfzode1402 : this.ArzeshAfzode1403);

        this.TR_Result.S_SumTotallAmount += Number(el.TotallAmount);

        //محاسبه مبالغ فاکتور با مبالغ قرارداد و فاکتورهای قبلا صادر شده
      });
      this.ListProducts.length == 0 ? (this.ErrorList = []) : false;
      this.IsCalc = true;
    },
    CalcDiscount(e, row) {
      row.Miniaturize_AmountDiscount =
        row.AmountKol - e.target.value.replace(/,/g, "").replace(/\./g, "");
      row.SumTollTax =
        Number(
          row.AmountKol - e.target.value.replace(/,/g, "").replace(/\./g, "")
        ) *(this.DataAxios.TempFactorDate.substring(0, 4)<'1403' ? this.ArzeshAfzode1402 : this.ArzeshAfzode1403);
      row.TotallAmount = row.Miniaturize_AmountDiscount + row.SumTollTax;
      this.CalcFactor();
    },
    CalcDiscountDetail(e, row) {
      row.Miniaturize_AmountDiscount = row.AmountKol - row.Discount;
      row.SumTollTax = Number(row.AmountKol - row.Discount);
      row.TotallAmount = row.Miniaturize_AmountDiscount + row.SumTollTax;
      this.CalcFactor();
    },
    CalcAmount(e, row) {
      console.log(this.TempFactor);
      var d =
        typeof row.Discount === "string"
          ? Number(row.Discount.replace(/,/g, "").replace(/\./g, ""))
          : Number(row.Discount);
      if (e == null) {
        row.AmountKol = row.Amount * row.Count;
      } else {
        row.AmountKol =
          Number(e.target.value.replace(/,/g, "").replace(/\./g, "")) *
          row.Count;
      }
      row.Miniaturize_AmountDiscount = Number(row.AmountKol) - d;
      // console.log(this.DataAxios.isRasmi);
      if (this.DataAxios.isRasmi) {
        row.SumTollTax = Number(row.AmountKol - d) *(this.DataAxios.TempFactorDate.substring(0, 4)<'1403' ? this.ArzeshAfzode1402 : this.ArzeshAfzode1403);
      } else {
        row.SumTollTax = 0;
      }
      row.TotallAmount = row.Miniaturize_AmountDiscount + row.SumTollTax;
      this.CalcFactor();
    },
    CalcCount(e, row) {
      var d =
        typeof row.Discount === "string"
          ? Number(row.Discount.replace(/,/g, "").replace(/\./g, ""))
          : Number(row.Discount);
      if (typeof row.Amount != "number") {
        row.AmountKol =
          Number(row.Amount.replace(/,/g, "").replace(/\./g, "")) *
          e.target.value;
      } else {
        row.AmountKol = row.Amount * e.target.value;
      }
      row.Miniaturize_AmountDiscount = Number(row.AmountKol) - d;
      row.SumTollTax = (Number(row.AmountKol) - d) *(this.DataAxios.TempFactorDate.substring(0, 4)<'1403' ? this.ArzeshAfzode1402 : this.ArzeshAfzode1403);
      row.TotallAmount = row.Miniaturize_AmountDiscount + row.SumTollTax;
      this.CalcFactor();
    },
    Mab2persian(mab) {
      return Num2persian(mab) + " ریال ";
    },
    GetFactors(tblContractsId) {
      let DataAxios_GetData = {
        ArryfildValue: {},
        Method: "post",
        Action: "CustomerProduct/GetFactorCusromerProduct",
        Token: this.$session.get("Token"),
      };
      DataAxios_GetData.ArryfildValue.Id = tblContractsId;
      this.$PostData(DataAxios_GetData)
        .then((data) => {
          this.Factors = data;
        })
        .finally(() => {
          this.$store.state.renderComponentGrid = false;
          this.$nextTick(() => {
            this.$store.state.renderComponentGrid = true;
          });
        });
    },
    GetSerialNum() {
      // console.log(1, this.DataAxios.SerialId);
      let DataAxios_GetSeialFactor = {
        ArryfildValue: {},
        Method: "GET",
        Action: "TempFactor/SerialGEnarator",
        Token: this.$session.get("Token"),
      };
      this.$PostData(DataAxios_GetSeialFactor)
        .then((data) => {
          this.DataAxios.SerialId = data == null ? 1 : data;
          // console.log(2, this.DataAxios.SerialId);
        })
        .finally(() => {
          this.$store.state.renderComponentGrid = false;
          this.$nextTick(() => {
            this.$store.state.renderComponentGrid = true;
          });
        });
    },
    AddTempFactor() {
      if (this.$ValidForm("tempFactorAdd")) {
        var data = {
          TblTempFactor: {
            tblCustomerId: this.DataAxios.TblCustomerId,
            tblCustomerFinancialINvoiceID:
              this.DataAxios.tblCustomerFinancialINvoiceID,
            Serial: this.DataAxios.SerialId,
            TempFactorDate: this.DataAxios.TempFactorDate,
            TempDesc: this.DataAxios.TempDesc,
            Id: 565,
            dateTimeInsert: "",
            tblUsergrpIdInsert: this.$session.get("UserInfo").tblUserGrpId,
            isRasmi: this.DataAxios.isRasmi,
            tblUsergrpIdLastedit: null,
            dateTimeLastEdit: null,
          },
          TblTempFactorDetailList: [],
        };
        this.PishFactorList.forEach((element) => {
          data.TblTempFactorDetailList.push({
            Id: element.id,
            tblUsergrpIdInsert: this.$session.get("UserInfo").tblUserGrpId,
            tblProductsId: element.tblProductsId,
            count: element.Count,
            discount: element.Discount,
            totallAmount: element.TotallAmount,
            amount: element.Amount,
            NeedSubmit: element.NeedSubmit,
            NameProduct: element.NameProduct,
          });
        });
        this.$PostData({
          Action: "TempFactor/Add",
          Method: "POST",
          ArryfildValue: data,
        }).then((result) => {
          if (result.status == "success") {
            (this.$store.state.activeTab = 11),
              this.$router.push({
                name: "DetailCustomer",
                params: {
                  tblCustomerId: this.DataAxios.TblCustomerId,
                },
              });
          }
        });
      }
    },
    GetResultTblCostomerFinancial(data) {
      if (data.id != null) {
        this.DataAxios.tblCustomerFinancialINvoiceID = data.id;
      }
    },
    EditTempFactor() {
      var data = {
        TblTempFactor: {
          tblCustomerId: this.DataAxios.TblCustomerId,
          TempFactorDate: this.DataAxios.TempFactorDate,
          tblCustomerFinancialINvoiceID:
            this.DataAxios.tblCustomerFinancialINvoiceID,
          Serial: this.DataAxios.SerialId,
          Id: this.TempFactor.tempFactor.id,
          dateTimeInsert: this.DataAxios.dateTimeInsert,
          tblUsergrpIdInsert: this.DataAxios.tblUsergrpIdInsert,
          isRasmi: this.DataAxios.isRasmi,
          tblUsergrpIdLastedit: null,
          dateTimeLastEdit: null,
          TempDesc: this.DataAxios.TempDesc,
        },
        TblTempFactorDetailList: [],
      };
      this.PishFactorList.forEach((element) => {
        data.TblTempFactorDetailList.push({
          Id: element.id,
          tblProductsId: element.tblProductsId,
          count: element.Count,
          discount: element.Discount,
          totallAmount: element.TotallAmount,
          amount: element.Amount,
          tblUserGrpIdInsert: element.tblUserGrpIdInsert,
          dateTimeInsert: element.dateTimeInsert,
          NameProduct: element.NameProduct,
          NeedSubmit: element.NeedSubmit,
        });
      });
      this.$PostData({
        Action: "TempFactor/Edit",
        Method: "POST",
        ArryfildValue: data,
      }).then((result) => {
        if (result.status == "success") {
          this.$router.push({
            name: "DetailCustomer",
            params: {
              tblCustomerId: this.DataAxios.TblCustomerId,
              activeTab: 11,
            },
          });
        }
      });
    },
    GetResultPishNevis(data) {
      if (data.id != null) {
        this.DataAxios.TempDesc = data.name;
        this.render = false;
        this.$nextTick(() => {
          this.render = true;
        });
      }
    },
  },
  mounted() {
    this.GetProducts();
    if (this.propstblCustomerProducts) {
      // console.log("IF 1");
      this.DataAxios.TblCustomerId =
        this.propstblCustomerProducts[0].TblCustomerId;
      this.refGetResulContract = this.propstblCustomerProducts[0].TblContractId;
      this.propstblCustomerProducts.forEach((element) => {
        element.Name = element.Name;
        var n = element;
        n["Count"] = 1;
        n["AmountKol"] = element.Amount * n.Count;
        n["SumTollTax"] = element.Toll + element.Tax;
        if (typeof element.Amount === "string") {
          element.Amount = Number(
            element.Amount.replace(/,/g, "").replace(/\./g, "")
          );
        }
        if (typeof element.Discount === "string") {
          element.Discount = Number(
            element.Discount.replace(/,/g, "").replace(/\./g, "")
          );
        }
        n["Miniaturize_AmountDiscount"] = element.Amount - element.Discount;
        n.Amount = this.$Comma3ragham(n.Amount);
        n.Discount = this.$Comma3ragham(n.Discount);

        this.ListProducts.push(n);
        this.CalcFactor();
        this.value.push(element.Id);
      });
    }
    if (this.InTempFactor) {
      // console.log("IF 2");

      this.GetTempFactor();
    } else {
      // console.log("IF 3");

      this.DataAxios.IssueDate = this.$GetJalaliDate();
      this.GetSerialNum();
    }
    if (this.propsCustomerId) {
      // console.log("IF 4");

      this.DataAxios.TblCustomerId = this.propsCustomerId;
    }
    if (!this.InTempFactor && this.PishFactorList.length > 0) {
      // console.log("IF 5");

      this.DataAxios.TempFactorDate = this.$store.state.JalaliDate;
      this.DataAxios.isRasmi = true;
    }
  },
};
</script>
<style scoped>
.D_Products {
  background: var(--sidebar-action-bg);
  border-radius: 5px;
}
tr {
  color: var(--sidebar-color-item) !important;
}
table {
  background: var(--sidebar-bg-color) !important;
  color: var(--sidebar-color-item);
}
td {
  border-color: var(--table-border-color) !important;
}
th {
  font-weight: normal;
  text-align: center;
  font-size: 12px;
  color: var(--sidebar-color-item) !important;
  border-color: var(--table-border-color) !important;
}
thead {
  border-color: var(--table-border-color) !important;
}
tr:hover {
  color: var(--sidebar-color-item) !important;
  background: var(--sidebar-bg-color) !important;
}
#header-Selected {
  width: 5% !important;
}
.borderd span:not(.fas):not(.fad) {
  color: rgb(253, 93, 8) !important;
}

td input {
  font-size: 10px !important;
}

td {
  font-size: 10px;
}
</style>
